import { RawLocation, Route, RouteConfig } from 'vue-router'
import { AuthUser, Location, User } from '../models'

/*** Permissions ***/
import { DashboardRouteNames } from '@/routes/constants/location'
// import TeamSettingsPage from '@/pmd/pages/settings/TeamSettingsPage.vue';
import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import MediaSettings from '@/pmd/pages/medias/MediaSettings.vue' 
import ReportingCustomContainer from '@/pmd/pages/reporting/reports/CustomReportsContainer.vue'
import { Modules } from '../util/modules'
// media files
import TriggerLinks from '@/pmd/pages/links/TriggerLinks.vue'
import { locationRoutes } from '@/routes/location/'
import first from "lodash-es/first"
import keys from "lodash-es/keys"

import store from '../store'
import { requireAuthAndLocation, _requireAccessLevelAndLocation } from './auth'
import { routePaths } from './paths'
import { locationSettingsRoute } from '@/routes/location/settings'

// ====================================================== //
// ========================================================== //
/*** Agency Level Settings Components: ***/

const ProfileSettingsV2 = () =>
  import('@/pmd/pages/settings/Profile.vue').then(m => m.default)

const AccountTeamManagement = () =>
  import(
    /* webpackChunkName: "team-management" */ '@/pmd/pages/agency/AccountTeamManagement.vue'
  ).then(m => m.default)


// ====================================================== //
/*** Report Adwords Components: ***/

// ========================================================== //
/*** Location Level Components: ***/
// const SideBar = () => import("@/pmd/components/locations/LocationSideBar.vue").then(m => m.default)
const LocationParent = () =>
  import(/* webpackChunkName: "location" */ '@/pmd/pages/LocationParent.vue')

const AffiliateManagerDashboard = () =>
  import(
    /* webpackChunkName: "affiliate-manager" */ '@/pmd/pages/AffiliateManager.vue'
  )



const CustomObjectsPage = () =>
  import(
    /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectsPage.vue'
    )

const CreateCustomObjectModal = () =>
  import(
    /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CreateCustomObject.vue'
    )

const CustomObjectSchemaInfo = () =>
  import(
  /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectSchemaInfo.vue'
  )

  const CustomObjectSchemaDetails = () =>
  import(
  /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectSchemaDetails.vue'
  )

  const CustomObjectAssociations = () =>
  import(
  /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectAssociations.vue'
  )

  const ConfigureAddRecordModal = () =>
  import(
  /* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/ConfigureAddRecordModal.vue'
  )

const CustomerImportsPage = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/customers/ContactBulkRequests.vue'
  )

const CustomerRestore = () =>
  import('@/pmd/pages/contact/RestorePage.vue')



// ========================================================== //
/*** Location Level Settings Components: ***/



const SocialPostingSettings = () =>
  import(
    /* webpackChunkName: "location-social-settings" */ '@/pmd/pages/settings/SocialPostingSettings.vue'
  ).then(m => m.default)
const CRMSettings = () =>
  import(
    /* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/CRMSettings.vue'
  ).then(m => m.default)

const AppointmentWidgetSettings = () =>
  import(
    /* webpackChunkName: "location-appointment-settings" */ '@/pmd/pages/settings/AppointmentWidgetSettings.vue'
  )
const ChatWidgetSettings = () =>
  import(
    /* webpackChunkName: "location-chat-settings" */ '@/pmd/pages/settings/ChatWidgetSettings.vue'
  ).then(m => m.default)
const NoShowSMSSettings = () =>
  import(
    /* webpackChunkName: "location-nosms-settings" */ '@/pmd/pages/settings/NoShowSMSSettings.vue'
  ).then(m => m.default)
const BirthdaySMSSettings = () =>
  import(
    /* webpackChunkName: "location-birthday-sms-settings" */ '@/pmd/pages/settings/BirthdaySMSSettings.vue'
  ).then(m => m.default)



const TemplateSettings = () =>
  import(
    /* webpackChunkName: "location-template-settings" */ '@/pmd/pages/settings/TemplateMessageSettings.vue'
  )
const FormBuilderPage = () =>
  import(
    /* webpackChunkName: "m-form-builder" */ '@/pmd/pages/marketing/FormBuilderPage.vue'
  ).then(m => m.default)

const QrCodePage = () =>
  import(
    /* webpackChunkName: "m-qr-code" */ '@/pmd/pages/marketing/QrCodePage.vue'
  ).then(m => m.default)

const Emails = () => import('@/pmd/pages/emailBuilder/Emails.vue')
const TextBuilder = () =>
  import(
    /* webpackChunkName: "m-text-builder" */ '@/pmd/pages/marketing/TextTemplates.vue'
  ).then(m => m.default)

const MediaSettings = () =>
  import(
    /* webpackChunkName: "media-center" */ '@/pmd/pages/medias/MediaFiles.vue'
  )

const ISVApp = () => import('@/pmd/pages/isv/ISVApp.vue')


const ElizaFAQSetting = () =>
  import(
    /* webpackChunkName: "bot-faq" */ '@/pmd/pages/agency/ElizaFAQSetting.vue'
  ).then(m => m.default)

const WordpressAppIndexPage = () =>
  import(
    /* webpackChunkName: "wordpress-dashboard" */ '@/pmd/pages/wordpress/WordpressAppIndexPage.vue'
  )

export const v2: RouteConfig[] = [
  {
    path: '/v2/location/:location_id',
    name: 'location-v2',
    component: LocationParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'crm-settings',
        name: 'crm-settings',
        component: CRMSettings,
        beforeEnter: _requireAccessLevelAndLocation,
      },
      {
        path: 'wordpress',
        name: 'wordpress-v2',
        meta: { translations: [ Modules.Wordpress ] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/:component',
        name: 'wordpress-v2',
        meta: { translations: [ Modules.Wordpress ] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/:wpId/:component',
        name: 'wordpress-v2',
        meta: { translations: [ Modules.Wordpress ] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/*',
        name: 'wordpress-v2',
        meta: { translations: [ Modules.Wordpress ] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/wordpress/*',
        redirect: 'wordpress',
      },
      {
        path: 'media-storage',
        name: 'media-settings-v2',
        component: MediaSettings,
        beforeEnter: requireAuthAndLocation,
        meta: {
          router_version: 'v2',
          hideTopBar: true,
        },
      },
      {
        path: 'settings',
        name: 'settings-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          ...locationSettingsRoute,

          {
            path: 'settings-profile',
            name: 'settings-profile-v2',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'profile',
            name: 'profile-v2',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'noshow_sms',
            name: 'no_show_sms_settings-v2',
            component: NoShowSMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'birthday_sms',
            name: 'birthday_sms_settings-v2',
            component: BirthdaySMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'social_posting',
            name: 'social_posting-v2',
            component: SocialPostingSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'chat_widget',
            name: 'chat_widget-v2',
            component: ChatWidgetSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.ChatWidgetBuilder] },
          },
          {
            path: 'appointment_widget',
            name: 'appointment-widget-2',
            component: AppointmentWidgetSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: 'template-settings-v2',
            component: TemplateSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'objects',
            name: 'objects',
            beforeEnter: requireAuthAndLocation,
            component: EmptyRouterParent,
            children: [
              {
                path: '/',
                name: 'custom-objects-list',
                component: CustomObjectsPage,
                children: [
                  {
                    path: 'create',
                    name: 'custom-objects-create',
                    component: CreateCustomObjectModal
                  }
                ]
              },
              {
                path: ':customObjectId',
                name: 'custom-object',
                component: EmptyRouterParent,
                children:[
                  {
                    path: '/',
                    name: 'custom-object-schema',
                    component: CustomObjectSchemaInfo,
                    children: [
                      {
                        path: 'details',
                        name: 'custom-object-details',
                        component: CustomObjectSchemaDetails,
                      },
                      {
                        path: 'associations',
                        name: 'custom-object-associations',
                        component: CustomObjectAssociations,
                      },
                      {
                        path:'customize-record-modal',
                        name: 'customize-record-modal',
                        component: ConfigureAddRecordModal,
                      }
                    ]
                  },
                ],
              },
            ],
          },
          {
            path: 'eliza_faq',
            name: 'eliza-faq-v2',
            component: ElizaFAQSetting,
            beforeEnter: async (to, from, next) => {
              const location = await Location.getById(to.params.location_id)
              store
                .dispatch('auth/get')
                .then((auth: AuthUser) => {
                  if (location && !location.botService)
                    next({
                      name: DashboardRouteNames.default,
                      replace: true,
                      params: { location_id: to.params.location_id },
                    })
                  next()
                })
                .catch(err => {
                  next()
                })
            },
          },
        ],
      },
      {
        path: 'settings/qr-codes',
        redirect: 'qr-codes',
      },
      {
        path: 'qr-codes/*',
        redirect: 'qr-codes',
      },
      {
        path: 'qr-codes',
        name: 'qr-codes',
        component: QrCodePage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'settings/conversation-ai-v2/:catchAll(.*)*',
        name: 'conversation-ai-v2',
        beforeEnter: requireAuthAndLocation,
        redirect: to => {
          return { path: `ai-agents/conversation-ai/${to.params.catchAll || ''}`, query: to.query, hash: to.hash }
        },
      },
      ...locationRoutes,
    ],
  },
]
